module.exports = __webpack_public_path__ + "static/aAbout page-06-df41b665afd9e4313b41a243360542ae.png";